// eslint-disable-next-line jira/filename-case
import React from 'react';
import { render } from 'react-dom';
import log from '@atlassian/jira-common-util-logging/src/log.tsx';
import { JiraContextContainer } from '@jira/platform__jira-context-container/src/JiraContextContainer.tsx';
import { FlagsBoundary } from '@jira/platform__flags-boundary/src/FlagsBoundary.tsx';
import { StrictMode } from '@atlassian/jira-react-strict-mode/src/StrictMode.tsx';
import { lazyForPaint, lazyAfterPaint } from '@atlassian/react-loosely-lazy';

const throwError = (message: string) => {
	const error = new Error(message);
	log.safeErrorWithoutCustomerData('flags.entry', message, error);
	throw error;
};

const getContainer = () => {
	// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
	let container = document.getElementById('flags');
	if (container == null) {
		// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
		container = document.createElement('div');
		container.id = 'flags';

		// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
		if (document.body) {
			// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
			document.body.appendChild(container);
		} else {
			throwError('document.body was not found whilst trying to create the flags container');
		}
	}
	return container;
};

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const Flags = lazyForPaint(
	() => import(/* webpackChunkName: "async-flags" */ '@atlassian/jira-flag-app/src/main.tsx'),
	{ ssr: false },
);

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const AfterPaintFlags = lazyAfterPaint(
	() =>
		// eslint-disable-next-line jira/import/webpack-magic-comment-entries
		import(/* webpackChunkName: "async-flags" */ '@atlassian/jira-flag-app/src/main.tsx'),
	{ ssr: false },
);

export const renderFlags = (): void =>
	render(
		<StrictMode>
			<JiraContextContainer>
				<FlagsBoundary packageName="flags-entry">
					{__SPA__ ? <AfterPaintFlags /> : <Flags />}
				</FlagsBoundary>
			</JiraContextContainer>
		</StrictMode>,
		getContainer(),
	);
